import pick from 'lodash/pick';
import { setAppMode } from '../store/actions/ui';
import { setModules, getModules } from '../store/actions/module';
import { setLocale } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { setStudentData } from '../store/actions/student';

export const loadUser = (dispatch, lwtStoreDispatch) => async response => {
  const { settings, ...data } = pick(response, [
    'id',
    'firstName',
    'lastName',
    'username',
    'gradeLevel',
    'classroom',
    'settings'
  ]);

  dispatch(setStudentData(data));
  lwtStoreDispatch.setSettings(settings);
  setLocale(response.locale);

  if (!response.liteSession) {
    const { data: modules } = await getModules();

    dispatch(setAppMode('curriculum'));
    dispatch(setModules(modules || []));
  }
};
